module.exports = __webpack_public_path__ + "static/media/Fichier 20.aaf0feca.svg";